export const version = "1.7.16";
export const channel = "core";
export const gitcommit = "unknown";
